"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmPropertyHeading = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var RequiredLabel_1 = require("../RequiredLabel");
var Wrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n\n  label: ConfirmHeadingWrapper;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n\n  label: ConfirmHeadingWrapper;\n"])));
var LABEL_WIDTH = '40px';
var Heading = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 14px;\n  line-height: 1.7;\n  color: ", ";\n  word-break: break-all;\n  font-weight: normal;\n  text-align: left;\n  width: 100%;\n\n  label: ConfirmHeading;\n"], ["\n  font-size: 14px;\n  line-height: 1.7;\n  color: ", ";\n  word-break: break-all;\n  font-weight: normal;\n  text-align: left;\n  width: 100%;\n\n  label: ConfirmHeading;\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var RequiredLabelWrapper = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: ", ";\n  padding-left: 8px;\n\n  label: ConfirmHeadingRequired;\n"], ["\n  width: ", ";\n  padding-left: 8px;\n\n  label: ConfirmHeadingRequired;\n"])), LABEL_WIDTH);
var ConfirmPropertyHeading = function (_a) {
    var name = _a.name, displayRequiredLabel = _a.displayRequiredLabel, required = _a.required, color = _a.color;
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement(Heading, { color: color, dangerouslySetInnerHTML: {
                __html: name,
            } }),
        displayRequiredLabel && (react_1.default.createElement(RequiredLabelWrapper, null,
            react_1.default.createElement(RequiredLabel_1.RequiredLabel, { required: required })))));
};
exports.ConfirmPropertyHeading = ConfirmPropertyHeading;
var templateObject_1, templateObject_2, templateObject_3;
